import type { EndpointProbeRequest } from "./api.ts";

// The check to keep with a save: a finished check of exactly what is being
// saved (same service, address and key, and one of its models), else null.
export function keptProbeId(input: {
  checked: { probeId: string; request: EndpointProbeRequest } | null;
  completed: boolean;
  removeKey: boolean;
  existing: { name: string; baseUrl: string } | null;
  name: string;
  baseUrl: string;
  apiKey: string;
  modelIds: string[];
}): string | null {
  const { checked, existing } = input;
  if (!checked || !input.completed || input.removeKey) return null;
  const req = checked.request.endpoint;
  const sameTarget =
    typeof req === "string"
      ? req === existing?.name && input.baseUrl === existing.baseUrl && !input.apiKey
      : req.name === input.name && req.baseUrl === input.baseUrl && (req.apiKey ?? "") === input.apiKey;
  return sameTarget && input.modelIds.includes(checked.request.model) ? checked.probeId : null;
}
